import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#5C4033', // Brown
      light: '#8B7355', // Light brown
      dark: '#3E2723', // Dark brown
    },
    secondary: {
      main: '#DAA520', // Golden rod
      light: '#F5F5DC', // Beige
      dark: '#8B4513', // Saddle brown
    },
    background: {
      default: '#F5F5DC', // Beige
    },
  },
  typography: {
    fontFamily: '"Cormorant Garamond", Calibri, serif',
    h1: {
      fontFamily: '"Tangerine", Calibri, cursive',
      fontWeight: 700,
      fontSize: '3.5rem',
      letterSpacing: '0.5px',
    },
    h2: {
      fontFamily: '"Tangerine", Calibri, cursive',
      fontWeight: 700,
      fontSize: '3rem',
      letterSpacing: '0.5px',
    },
    h3: {
      fontFamily: '"Tangerine", Calibri, cursive',
      fontWeight: 700,
      fontSize: '2.5rem',
      letterSpacing: '0.5px',
    },
    button: {
      fontFamily: '"Cormorant Garamond", Calibri, serif',
      textTransform: 'none',
      fontSize: '1.1rem',
    },
    body1: {
      fontSize: '1.1rem',
    },
    body2: {
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '4px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
          },
        },
      },
    },
  },
});

export default theme;